import { Injectable, inject } from '@angular/core'
import { FeedbackHistoryStoreService } from './feedback-history-store.service'
import { SearchFeedbackRequestDTO } from '../../../apiModule'

@Injectable({ providedIn: 'root' })
export class FeedbackHistoryControllerService {
  private readonly store = inject(FeedbackHistoryStoreService)

  // Expose state as readonly signals
  readonly search = this.store.feedbackHistoryState.search
  readonly scroll = this.store.feedbackHistoryState.scroll
  readonly isLoading = this.store.feedbackHistoryState.isLoading
  readonly error = this.store.feedbackHistoryState.error

  // Update search filters
  updateSearch(search: SearchFeedbackRequestDTO): void {
    this.store.updateSearch(search)
  }

  // Update scroll position
  updateScroll(scroll: number): void {
    this.store.updateScroll(scroll)
  }

  // Reset state
  reset(): void {
    this.store.reset()
  }
}
